export const IMAGE_LOADER_CONSTS = {
  addCoverImageMsg: 'Добавить обложку',
  linkFromPhotoBankMsg: 'Ссылка из фотобанка',
  setAnotherPhotoLabelMsg: 'Установить другое фото'
}
